<template>
  <v-app>
    
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      v-show="isAuthenticated"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-action class="mr-0 mb-0">
            <img src="/img/icons/apple-touch-icon-60x60.png" alt="logo" />
          </v-list-item-action>
        </v-list-item-content>
      </v-list-item>
      <v-list>
        <v-list-item to="/controllers">
          <v-list-item-action>
            <v-icon>mdi-home-assistant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Moje sterowniki') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!--<template v-if="controller">
          <v-divider></v-divider>
          <v-list-item  v-for="(item, i) in controllerMenu"
          :key="i" 
          :to="item.url">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title :class="{ 'body-2': i > 0 }">{{ (i > 0) ? $t(item.title) : item.title }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="item.counter">
              <v-chip
                small
                color="primary"
              >{{ item.counter }}</v-chip>
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
        </template>-->

        <v-list-item to="/settings">
          <v-list-item-action>
            <v-icon>mdi-tune</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Opcje') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item 
        key="logout" 
        @click="logout">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Wyloguj') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    
    <router-view name="top" :drawer.sync="drawer" :title="metaTitle"></router-view>

    <v-content :class="{noauth: !isAuthenticated}">
      <transition name="router-anim" mode="out-in">
        <router-view/>
      </transition>
      <router-view name="fab"/>
      <dialog-alerts :showAlerts="showAlerts"></dialog-alerts>
      <snack-alert></snack-alert>
      <v-snackbar
        v-model="snackWithButtons"
        :timeout="timeout"
        :multi-line="true"
      >
        {{ snackWithBtnText }}
        <v-spacer />
        <v-btn
          text
          color="blue"
          @click.native="refreshApp"
        >
          {{ snackBtnText }}
        </v-btn>
        <v-btn
          icon
          color="red"
          @click="snackWithButtons = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
  import SnackAlert from '@/components/SnackAlert.vue'
  import DialogAlerts from '@/components/DialogAlerts.vue'
  import { mapActions, mapGetters } from 'vuex'
  export default {
    data () {
      return {
        drawer: null,
        showAlerts: false,
        registration: null,
        snackBtnText: '',
        snackWithBtnText: '',
        snackWithButtons: false,
        timeout: 0,
      }
    },
    computed: {
      ...mapGetters([
        'controllerById', 'isAuthenticated'
      ]),
      metaTitle() {
        return this.$route.meta.title;
      },
      controllerId() {
        return this.$route.params.controllerId;
      },
      controller() {
        return (this.controllerId) ? this.controllerById(this.controllerId) : null
      },
      /*controllerMenu() {
        return (this.controller !== null && false) ? [
          { title: this.controller.displayName, url: '/dashboard/' + this.controllerId, icon: 'mdi-gauge' },
          { title: 'Powiadomienia', url: '/notifications/' + this.controllerId, counter: this.$store.getters['notifications/countByController'](this.controllerId), icon: 'mdi-bell-ring-outline' },
          { title: 'Uzytkownicy', url: '/users/' + this.controllerId, icon: 'mdi-account-multiple' },
          { title: 'Ustawienia', url: '/controller/' + this.controllerId, icon: 'mdi-settings' },
        ] : null
      }*/
    },
    created () {
      this.$store.dispatch('resurrect'); //przywroc usera z local storage
      this.$store.dispatch('resurrectControllers'); //przywroc liste sterownikow z local storage
      
      // Listen for swUpdated event and display refresh snackbar as required.
      document.addEventListener('swUpdated', this.showRefreshUI, { once: true });
      // Refresh all open app tabs when a new service worker is installed.
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.refreshing) return;
        this.refreshing = true;
        window.location.reload();
      });
    },
    methods: {
      ...mapActions([
        'logout'
      ]),
      showRefreshUI(e) {
        // Store the ServiceWorkerRegistration instance for later use.
        this.registration = e.detail;
        this.snackBtnText = 'Pobierz';
        this.snackWithBtnText = 'Nowa wersja dostępna!';
        this.snackWithButtons = true;
      },
      refreshApp() {
        this.snackWithButtons = false;
        // Protect against missing registration.waiting.
        if (!this.registration || !this.registration.waiting) { return; }
        this.registration.waiting.postMessage('skipWaiting');
      }
    },
    components: {
      SnackAlert, DialogAlerts
    }
  }
</script>

<style>
.router-anim-enter-active {
  animation: coming 0.15s;
  opacity: 0;
  overflow: hidden;
}
.router-anim-leave-active {
  animation: going 0.15s;
  overflow: hidden;
}
@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-40px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(-40px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.tab-anim-enter-active {
  animation: comingtab 0.15s;
  opacity: 0;
  overflow: hidden;
}
.tab-anim-leave-active {
  animation: goingtab 0.15s;
  overflow: hidden;
}
@keyframes goingtab {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(40px);
    opacity: 0;
  }
}
@keyframes comingtab {
  from {
    transform: translateX(-40px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>